/* eslint-disable */
import sendRequest from "../../resources/js/utils/sendRequest";

window.addEventListener('load', function() {
    changeQuantity();
    changeSelects();
});

function adjustQuantityFontSize(input) {
    if (!input) {
        return;
    }
    const digits = String(input.value).length;
    input.classList.remove('quantity-input--2', 'quantity-input--3');
    if (digits >= 3) {
        input.classList.add('quantity-input--3');
    } else if (digits === 2) {
        input.classList.add('quantity-input--2');
    }
}

/**
 * Subtle “pop” when quantity changes via +/- (smoother feel together with font-size transition).
 */
function playQuantityValueBump(input) {
    if (!input) {
        return;
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }
    input.classList.remove('quantity-input--value-bump');
    void input.offsetWidth;
    input.classList.add('quantity-input--value-bump');
    const onEnd = function () {
        input.classList.remove('quantity-input--value-bump');
        input.removeEventListener('animationend', onEnd);
    };
    input.addEventListener('animationend', onEnd);
}

function changeQuantity() {
    const moreBtn = document.querySelector('.highlighted-product-block .quantity-btn.more');
    const lessBtn = document.querySelector('.highlighted-product-block .quantity-btn.less');
    const quantityInput = document.querySelector('.highlighted-product-block .quantity-input');
    const addToCartBtn = document.querySelector('.highlighted-product-block .js-add-to-cart');

    if (moreBtn) {
        moreBtn.addEventListener('click', function() {
            let currentValue = parseInt(quantityInput.value) || 1;
            quantityInput.value = currentValue + 1;
            adjustQuantityFontSize(quantityInput);
            playQuantityValueBump(quantityInput);
        });
    }

    if (lessBtn) {
        lessBtn.addEventListener('click', function() {
            let currentValue = parseInt(quantityInput.value) || 1;
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
                adjustQuantityFontSize(quantityInput);
                playQuantityValueBump(quantityInput);
            }
        });
    }

    if (quantityInput) {
        quantityInput.addEventListener('input', function() {
            adjustQuantityFontSize(quantityInput);
        });
        adjustQuantityFontSize(quantityInput);
    }

    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', async function(event) {
            event.preventDefault();
            const quantity = parseInt(quantityInput.value) || 1;
            const productId = addToCartBtn.dataset.variationId;

            addToCartBtn.disabled = true;

            try {
                const response = await fetch(`?add-to-cart=${productId}&quantity=${quantity}`, {
                    headers: { 'X-Requested-With': 'XMLHttpRequest' }
                });

                if (response.ok) {
                    showAddToCartSuccess();
                    refreshCartFragments();
                }
            } catch (e) {
                console.error('Add to cart error:', e);
            } finally {
                addToCartBtn.disabled = false;
            }
        });
    }
}

function changeSelects() {
    const productID = document.querySelector('.highlighted-product-block [data-product-id]').getAttribute('data-product-id');
    const desiredVolume = document.querySelector('.highlighted-product-block select[name="volume"]');
    const desiredShape = document.querySelector('.highlighted-product-block select[name="form"]');

    if (desiredVolume && desiredShape) {
        desiredVolume.addEventListener('change', function() {
            updateVariant(productID, desiredVolume.value, desiredShape.value);
        });
        desiredShape.addEventListener('change', function() {
            changeImage(desiredShape);
            updateVariant(productID, desiredVolume.value, desiredShape.value, true);
        });
    }
}

function changeImage(element) {
    const imgEl = document.querySelector('.highlighted-product-block .image-wrapper img');
    const newImage = element.options[element.selectedIndex].dataset.image;
    if (imgEl && newImage) {
        // Fade out animation
        imgEl.classList.add('fade-out');
        
        // After fade out completes, change image and fade in
        setTimeout(() => {
            imgEl.src = newImage;
            
            imgEl.onload = () => {
                imgEl.classList.remove('fade-out');
                imgEl.classList.add('fade-in');

                // Remove fade-in class after animation completes
                setTimeout(() => {
                    imgEl.classList.remove('fade-in');
                }, 300);
            };
        }, 400);
    }
}

async function updateVariant(productId, desiredVolume, desiredShape, changeShape = false) {
    const addToCartBtn = document.querySelector('.highlighted-product-block .js-add-to-cart');
    const price = document.querySelector('.highlighted-product-block .price');
    const currency = document.querySelector('.highlighted-product-block .currency-wrapper').dataset.currency;
    const formData = new FormData();
    formData.append('productId', productId);
    formData.append('volume', desiredVolume);
    formData.append('form', desiredShape);
    formData.append('currency', currency);
    formData.append('changeShape', changeShape ? true : false);

    const response = await sendRequest({method: 'POST', data: formData, endpoint: 'select_variant'});
    const data = await response.data;

    if (data.price && !changeShape) {
        price.textContent = data.price;
    }
    if (data.variationId && !changeShape) {
        addToCartBtn.dataset.variationId = data.variationId;
    }

    if (data.volumeEmpty || changeShape) {
        const volumeSelectWrapper = document.querySelector('.highlighted-product-block .js-desired-volume');
        if (volumeSelectWrapper) {
            const select = volumeSelectWrapper.querySelector('select.sk-select');

            if (select) {
                // Rebuild options from server-provided volumes array
                select.innerHTML = '';

                if (Array.isArray(data.volumes)) {
                    data.volumes.forEach((vol) => {
                        const opt = document.createElement('option');
                        opt.value = vol;
                        opt.textContent = vol;
                        select.appendChild(opt);
                    });
                }

                // Reset selection to first option and notify any listeners
                select.selectedIndex = 0;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }
}

function refreshCartFragments() {
    fetch('/?wc-ajax=get_refreshed_fragments', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
    .then(res => res.json())
    .then(data => {
        if (data && data.fragments) {
            // Update cart count badge if exists
            const cartCount = document.querySelectorAll('.cart-wrapper-icon');
            if (cartCount && data.cart_hash) {
                cartCount.forEach((el) => {
                    el.classList.remove('is-empty');
                });
            }
        }
    })
    .catch(() => {});
}

function successCheckIconSvg() {
    const uid = `hp-${Math.random().toString(36).slice(2, 10)}`;
    return `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" aria-hidden="true" class="add-to-cart-success__svg" focusable="false"><g clip-path="url(#${uid}_clip)"><path d="M17.9301 0.44899C14.3399 -0.149663 10.6754 -0.149663 7.08524 0.44899C3.67945 1.01073 1.01012 3.68169 0.448717 7.08955C-0.149572 10.6819 -0.149572 14.3486 0.448717 17.941C1.01012 21.3489 3.67945 24.0198 7.08524 24.5816C8.87818 24.8695 10.6918 25.0093 12.5077 24.9995C14.3244 24.9989 16.138 24.8487 17.9301 24.5503C21.3359 23.9886 24.0052 21.3176 24.5666 17.9097C24.8588 16.1213 25.0037 14.3118 24.9999 12.4996C24.9994 10.6818 24.8493 8.86709 24.551 7.07392C23.9855 3.67687 21.3251 1.01484 17.9301 0.44899ZM21.4865 17.4137C21.1441 19.5033 19.5071 21.1413 17.4187 21.4839C15.7952 21.7488 14.1526 21.8794 12.5077 21.8745C10.8627 21.8795 9.22015 21.7488 7.59664 21.4839C5.50823 21.1413 3.87127 19.5033 3.52884 17.4137C2.98719 14.1614 2.98719 10.8418 3.52884 7.58954C3.86974 5.49834 5.50704 3.85848 7.59664 3.51537C10.8469 2.97339 14.1645 2.97339 17.4148 3.51537C19.5047 3.85648 21.1436 5.49477 21.4865 7.58563C21.7513 9.21013 21.8819 10.8537 21.8769 12.4996C21.8818 14.1456 21.7513 15.7892 21.4865 17.4137Z" fill="white"/><path d="M14.9164 9.43714L11.3366 13.0191L9.70869 11.3902C9.09853 10.7797 8.10928 10.7797 7.49912 11.3902C6.88896 12.0008 6.88896 12.9906 7.49912 13.6012L9.57986 15.6832C10.5506 16.6527 12.1226 16.6527 13.0933 15.6832L17.126 11.6442C17.7361 11.0336 17.7361 10.0438 17.126 9.43324C16.5158 8.82271 15.5266 8.82271 14.9164 9.43324L14.9164 9.43714Z" fill="white"/></g><defs><clipPath id="${uid}_clip"><rect width="25" height="25" fill="white"/></clipPath></defs></svg>`;
}

function clearAddToCartSuccessUi() {
    document.querySelectorAll('.highlighted-product-block .add-to-cart-success').forEach((el) => el.remove());
    document.querySelectorAll('.highlighted-product-block .add-to-cart-success__check').forEach((el) => el.remove());
}

function showAddToCartSuccess() {
    const block = document.querySelector('.highlighted-product-block');
    const content = document.querySelector('.highlighted-product-block__content');
    if (!content) return;

    clearAddToCartSuccessUi();

    const bottom = content.querySelector('.bottom');
    const addBtn = content.querySelector('.js-add-to-cart');
    const loader = content.querySelector('.add-to-card-loader');
    if (!bottom || !addBtn) return;
    loader.classList.add('show');

    const cartLink =
        (block && block.dataset.cartUrl) ||
        document.querySelector('a.cart-wrapper')?.getAttribute('href') ||
        '/cart/';
    const label =
        (block && block.dataset.viewCartLabel) || 'Voir le panier';

    const check = document.createElement('span');
    check.className = 'add-to-cart-success__check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = successCheckIconSvg();
    addBtn.insertAdjacentElement('afterend', check);    

    const panel = document.createElement('div');
    panel.className = 'add-to-cart-success';
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');

    const btn = document.createElement('a');
    btn.className = 'add-to-cart-success__btn sk-btn';
    btn.href = cartLink;
    btn.textContent = label;

    panel.appendChild(btn);
    bottom.insertAdjacentElement('afterend', panel);

    const alignViewCartToAddButton = () => {
        const cr = content.getBoundingClientRect();
        const ar = addBtn.getBoundingClientRect();
        const left = ar.left - cr.left;
        panel.style.marginLeft = `${Math.max(0, left)}px`;
        panel.style.width = `${addBtn.offsetWidth}px`;
    };

    const motionMs = 520;
    
    setTimeout(() => {
        loader.classList.remove('show');
    }, 500);

    setTimeout(() => {
        requestAnimationFrame(() => {
            alignViewCartToAddButton();
            requestAnimationFrame(() => {
                panel.classList.add('is-expanded');
                check.classList.add('is-expanded');
            });
        });
    }, 800);

    const dismissMs = 5000;

    setTimeout(() => {
        check.classList.remove('is-expanded');
        setTimeout(() => {
            check.remove();
        }, motionMs);
    }, dismissMs);
}
